"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
require("@fancyapps/ui/dist/fancybox/fancybox.css");
const Footer_1 = require("@allpages/Footer");
const LanguageSelector_1 = require("./LanguageSelector");
const FancyboxManager_1 = require("./FancyboxManager");
const LanguageManager_1 = require("./LanguageManager");
const ImageHandler_1 = require("./ImageHandler");
const JsCheckManager_1 = require("./JsCheckManager");
const NavigationManager_1 = require("./NavigationManager");
const CookieBanner_1 = require("./CookieBanner");
const HeroText_1 = require("@homepage/HeroText");
const IntersectionObserverManager_1 = require("./IntersectionObserverManager");
const ButtonBehavior_1 = require("./ButtonBehavior");
const Trailer_1 = require("@homepage/Trailer");
const Overview_1 = require("@homepage/Overview");
const World_1 = require("@homepage/World");
const character_1 = require("@homepage/character");
const Navigation_1 = require("@allpages/Navigation");
const Custom_Select_1 = require("@products/Custom_Select");
const Products_text_update_1 = require("@products/Products_text_update");
const Videos_1 = require("@videos/Videos");
const Gameplay_1 = require("@gameplay/Gameplay");
const Gameplay_text_update_1 = require("@gameplay/Gameplay_text_update");
const updateMetatags_1 = require("./updateMetatags");
const Characters_1 = require("@characters/Characters");
const swiper_1 = require("./swiper");
const WorldText_1 = require("./world/WorldText");
document.addEventListener('DOMContentLoaded', () => {
    (0, JsCheckManager_1.enableJs)();
    (0, ImageHandler_1.replaceJpgWithWebp)();
    (0, updateMetatags_1.updateMetaTags)();
    FancyboxManager_1.FancyboxManager.initialize();
    LanguageManager_1.LanguageManager.initializeLanguage();
    new LanguageSelector_1.LanguageSelector();
    NavigationManager_1.NavigationManager.initialize();
    new Footer_1.Footer();
    CookieBanner_1.CookieBanner.checkAnalyticsOnOrOffAtStart();
    IntersectionObserverManager_1.IntersectionObserverManager.observeElements();
    (0, ButtonBehavior_1.setupButtonHover)();
    new Navigation_1.navigationContent();
    // Get the class of the body element
    const pageClass = document.body.classList[0]; // Assuming first class represents the page type
    switch (pageClass) {
        case 'home':
            new HeroText_1.HeroTextContent();
            new Trailer_1.homeTrailerContent();
            new Overview_1.homeOverviewContent();
            new World_1.homeWorldContent();
            new character_1.homeCharacterContent();
            break;
        case 'world_page':
            let carouselInstance = null;
            if (document.readyState === 'loading') {
                document.addEventListener('DOMContentLoaded', () => {
                    if (!carouselInstance)
                        carouselInstance = new swiper_1.Carousel();
                });
            }
            else {
                if (!carouselInstance)
                    carouselInstance = new swiper_1.Carousel();
            }
            new WorldText_1.WorldTextManager();
            break;
        case 'gameplay_page':
            new Gameplay_1.Gameplay();
            new Gameplay_text_update_1.gameplayContent();
            break;
        case 'characters_page':
            new Gameplay_1.Gameplay();
            new Characters_1.Characters();
            break;
        case 'videos_page':
            new Videos_1.videoContent();
            break;
        case 'products':
            new Custom_Select_1.CustomSelect();
            new Products_text_update_1.ProductsContent();
            break;
        default:
            // Default case if no specific logic is required
            break;
    }
});
